<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useSlots, computed } from 'vue';
import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import TabelaBase from '@/components/v2/base/TabelaBase/TabelaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    },
    disabled: {
        type: Boolean,
        default: false
    },
    selecao: {
        type: String,
        default: 'nenhum'
    },
    selecionados: {
        type: Array,
        default: () => []
    },
    selecionado: {
        type: Object,
        default: () => ({})
    },
    itemKey: {
        type: String,
        default: 'id'
    },
    paginacao: {
        type: String,
        default: 'nenhuma'
    },
    itensPorPagina: {
        type: Number,
        default: 10
    }
});

const emits = defineEmits([
    'update:selecionados',
    'update:selecionado',
]);

const slots = useSlots();

/*==================================================================*/
/*================== ALTERA SELECIONADOS/SELECIONADO ================*/
/*==================================================================*/

const alteraSelecionados = (selecionados) => {

    emits('update:selecionados', selecionados);

};

const alteraSelecionado = (selecionado) => {

    emits('update:selecionado', selecionado);

};

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('linha-item.'))

);

</script>

<template>

    <CartaoBase>

        <template #header>
            <slot name="header"></slot>
        </template>

        <template #body>

            <TabelaBase
                :headers="props.headers"
                :dados="props.dados"
                :disabled="props.disabled"
                :selecao="props.selecao"
                :selecionados="props.selecionados"
                :selecionado="props.selecionado"
                :item-key="props.itemKey"
                :paginacao="props.paginacao"
                :itens-por-pagina="props.itensPorPagina"
                @update:selecionados="alteraSelecionados"
                @update:selecionado="alteraSelecionado"
            >

                <template v-if="slots['linha-botoes']" #linha-botoes="slotProps">

                    <slot name="linha-botoes" v-bind="slotProps"></slot>

                </template>

                <template
                    v-for="name in slotsDeItem"
                    #[name]="slotProps"
                >

                    <slot :name="name" v-bind="slotProps ?? {}"></slot>

                </template>
                
            </TabelaBase>

        </template>

        <template #footer>
            <slot name="footer"></slot>
        </template>

    </CartaoBase>

</template>

<style scoped>
</style>
